module.exports = __webpack_public_path__ + "categories/icon-feature-calendar-4b277232780cc15318dc0e25d7fa02c6.svg";